import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScHostMessage implements ICommand
{

	public HostID : number = 0;
	public MsgID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.MsgID = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.MsgID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScHostMessage();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'MsgID(Q)='+this.MsgID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30776;
	}

	public getCmdName() : string
	{
		return 'ScHostMessage';
	}

}
